<template>
  <div v-if="!isNativeDevice">
    <v-row   class="footer" >
      <v-col cols="12">
        <p class="text-center pt-12 font-weight-medium white--text">
          {{ footerTitle }}
        </p>
      </v-col>

      <v-row justify="center" class="footer-inner mt-3 ma-auto">
        <v-col
          cols="6"
          lg="auto"
          md="auto"
          sm="3"
          v-for="(col, index) in footerLinks"
          :key="`cols-${index}`"
          class=""
        >
          <p class="white--text pb-2 text-decoration-underline display-12">
            {{ col.title }}
          </p>
          <ul>
            <li
              v-for="(item, i) in col.links"
              :key="`group1${i}`"
            >
              <nuxt-link
                :title="item.name"
                class="pb-0 display-12 white--text d-block"
                :to="item.link.trim()"
                :prefetch="false"
              >
                {{ item.name }}
              </nuxt-link>
            </li>
          </ul>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.xsOnly"></v-col>
        <v-col cols="12" class="pt-2">
          <v-row class="social-inner" justify="space-between">
            <v-col cols="12" sm="6" class="social-inner-ico">
              <a
                href="https://instagram.com/drushim__il?igshid=NTc4MTIwNjQ2YQ=="
                title="instagram"
                target="_blank"
              >
                <img src="~/assets/23/social/insta.svg" alt="instagram" />
              </a>

              <a
                href="https://www.linkedin.com/company/portal-drushim-israel/mycompany/?viewAsMember=true"
                title="linkedin"
                target="_blank"
              >
                <img src="~/assets/23/social/linkedin.svg" alt="linkedin" />
              </a>

              <a
                href="https://www.facebook.com/drushim.co.il?mibextid=ZbWKwL"
                title="facebook"
                target="_blank"
              >
                <img src="~/assets/23/social/facebook.svg" alt="facebook" />
              </a>
              <a
                href="https://www.youtube.com/@drushim"
                title="youtube"
                target="_blank"
              >
                <img src="~/assets/23/social/youtube.svg" alt="youtube" />
              </a>
            </v-col>
            <v-col cols="12" sm="6" class="social-inner-app">
              <a
                href="https://apps.apple.com/us/app/%D7%93%D7%A8%D7%95%D7%A9%D7%99%D7%9D-il/id1180529703"
                title="appstore"
                target="_blank"
              >
                <img src="~/assets/23/social/appstore.svg" alt="appstore" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=drushim.app"
                title="googleplay"
                target="_blank"
              >
                <img src="~/assets/23/social/googleplay.svg" alt="googleplay" />
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>

    <v-row>
      <v-col class="text-center pt-0 pb-0 px-2" cols="12">
        <p class="rtl text-center display-12 py-1 ma-0 px-3">
          דרושים IL - מגשימים 1, פתח תקווה. ליצירת קשר
          <a href="/contactus.aspx" title="צור קשר">לחץ כאן</a>
        </p>
      </v-col>
    </v-row>
    <v-row v-if="$vuetify.breakpoint.xsOnly ? true : false">
      <v-col class="py-0 text-center googleDec font-weight-thin">
        אתר זה מוגן באמצעות Google reCAPTCHA ומחוייב ל-
        <a :href="privacyPolicy" target="_blank">מדיניות הפרטיות</a>
        וכן
        <a :href="terms" target="_blank">תנאי השירות</a>
        של Google
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { get } from 'lodash';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import DeviceDetect from '@/components/mixins/DeviceDetect';

export default {
  mixins: [DeviceDetect],
  data() {
    return {
      urls: [],
      footerTitle: t('titles.footer'),
      privacyPolicy: 'https://www.google.com/intl/he/policies/privacy/',
      terms: 'https://www.google.com/intl/he/policies/terms/',
    };
  },
  computed: {
    ...mapState({
      footerLinks: (state) =>
        get(state, 'homeDrushim.data.footerLinks'),
    }),
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #363636;
  font-weight: normal;
  flex-direction: column;
}
.footer-inner {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 5px;
}

ul {
  list-style-type: none;
  line-height: 19px;
}
li a {
  color: #fff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
.credits img {
  width: 50px;
  vertical-align: sub;
}

.social-inner .icon {
  width: 36px;
  height: 36px;
}

.social-inner {
  max-width: 1070px;
  margin: 0 auto;
}

.social-inner .social-inner-app {
  display: flex;
  justify-content: flex-end;
}
.social-inner .social-inner-app a {
  width: 124px;
  height: 36px;
  display: inline-flex;
  margin: 0 8px;
}

.social-inner .social-inner-ico {
  display: flex;
}
.social-inner .social-inner-ico a {
  display: inline-flex;
  width: 36px;
  height: 36px;
  margin: 0 7px;
}

@media screen and (max-width: 768px) {
  .footer {
    min-height: 1000px;
  }
  .footer .footer-inner {
    max-width: 630px;
  }
}
@media screen and (max-width: 600px) {
  .social-inner .social-inner-ico {
    justify-content: center;
  }
  .social-inner .social-inner-app {
    justify-content: center;
  }
  .footer .footer-inner {
    max-width: 359px;
  }
  .googleDec {
    font-size: 9px;
    padding-top: 5px;
    color: gray;
    line-height: 11px;
    opacity: 0.5;
  }
}
</style>
